import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";
import template from "./sw-reader.mjs";
import Strings from "../../../models/Strings.json";
import { LANGUAGE, SW_AI, isApple } from "../../global.ts";
import { Books } from "../../../managers/Books.ts";
import Bedok from "../../../models/Bedok.json";
import { normalizeNumerals } from "../../../models/Number.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import { HeartBank } from "../../../managers/HeartBank.ts";
import { SwEditor } from "../../sw-header/sw-editor/sw-editor.ts";
import { SwDictionary } from "../sw-dictionary/sw-dictionary.ts";
import Words from "../../../models/Dictionary.json";

const LANGUAGE2 = "khmer";
const strings: any = Strings;
const bedok: any = Bedok;

export class SwReader extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private books: Books = new Books();
    private componentTrace: PerformanceTrace;
    private audio: HTMLAudioElement | null = null;

    private transcription: string | null = null; // ID
    private transcript: string | null = null; // rename to text
    private text: string | null = null; // TODO: later refactor as error message
    private editor = document.querySelector("sw-editor") as SwEditor;
    private dictionary = document.querySelector(
        "sw-dictionary"
    ) as SwDictionary;

    private editButton: HTMLElement;
    private editIcon: HTMLSpanElement;

    private khmer: HTMLElement;
    private modal: ModalInterface;
    private admin: HTMLElement;

    private body: HTMLElement;
    private body1: HTMLParagraphElement;
    private body2: HTMLParagraphElement;

    private pager: HTMLElement;
    private page: HTMLInputElement;
    private total: HTMLElement;
    private increment: HTMLButtonElement;
    private decrement: HTMLButtonElement;

    private close: HTMLButtonElement;
    private dict2: HTMLButtonElement;
    private close2: HTMLButtonElement; // deprecated

    private dict: HTMLButtonElement;
    private speak: HTMLButtonElement;
    private copy: HTMLButtonElement;
    private tutor: HTMLButtonElement;
    private quiz: HTMLButtonElement;

    private google: HTMLButtonElement;
    private chatgpt: HTMLButtonElement;
    private grok: HTMLButtonElement;

    private deepseek: HTMLElement;
    private gemini: HTMLButtonElement;
    private meta: HTMLElement;
    private other: HTMLElement; // not used

    private maxPage = 0;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-reader");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.editButton = this.querySelector("h3")!;
        this.editIcon = this.editButton.firstElementChild as HTMLSpanElement;
        this.admin = this.querySelector("#sw-reader-admin")!;

        this.khmer = this.querySelector("#sw-reader")!;
        this.body = this.querySelector("#sw-reader-body")!;
        this.body1 = this.body.firstElementChild as HTMLParagraphElement;
        this.body2 = this.body.lastElementChild as HTMLParagraphElement;

        this.pager = this.querySelector("#sw-reader-pager")!;
        this.page = this.querySelector("#sw-reader-pager-number")!;
        this.total = this.querySelector("#sw-reader-pager-total")!;
        this.increment = this.querySelector("#sw-reader-pager-increment")!;
        this.decrement = this.querySelector("#sw-reader-pager-decrement")!;

        this.meta = this.querySelector("#sw-reader-meta")!;
        this.gemini = this.querySelector("#sw-reader-gemini")!;
        this.deepseek = this.querySelector("#sw-reader-deepseek")!;
        this.other = this.querySelector("#sw-reader-other")!;

        this.google = this.querySelector("#sw-reader-google")!;
        this.grok = this.querySelector("#sw-reader-grok")!;
        this.chatgpt = this.querySelector("#sw-reader-chatgpt")!;

        this.tutor = this.querySelector("#sw-reader-tutor")!;
        this.quiz = this.querySelector("#sw-reader-quiz")!;
        this.dict = this.querySelector("#sw-reader-dict")!;
        this.dict2 = this.querySelector("#sw-reader-dict2")!;
        this.speak = this.querySelector("#sw-reader-speak")!;
        this.copy = this.querySelector("#sw-reader-copy")!;
        this.close = this.querySelector("#sw-reader-close")!;
        this.close2 = this.querySelector("#sw-reader-close2")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                if (this.audio) {
                    this.audio.pause();
                    this.speak.textContent = "🔈";
                }
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-reader",
            override: true
        };

        this.modal = new Modal(this.khmer, modalOptions, instanceOptions);
    }

    // attribute: lang = khmer or pali
    static get observedAttributes() {
        return ["lang"]; // List attributes you want to watch
    }

    attributeChangedCallback(
        name: string,
        oldValue: string | null,
        newValue: string | null
    ) {
        if (name === "lang") {
            const span = this.querySelector(
                "#sw-reader-title"
            ) as HTMLHeadingElement;
            span.textContent =
                newValue === "khmer"
                    ? strings.khmer3[LANGUAGE]
                    : strings.pali3[LANGUAGE];
        }
    }

    async connectedCallback() {
        this.editButton.addEventListener("click", () => {
            if (this.transcription && this.heartbank.isAdmin()) {
                this.hide();
                this.editor.show(
                    this.transcription!, // can be null if error creating new firestore doc using client OCR
                    this.getAttribute("lang")!,
                    this.transcript,
                    this
                );
            }
        });

        //deprecated
        // this.heartbank.addAuthStateListener3(() => {
        //     if (!isApple || this.heartbank.isAdmin())
        //         this.dict2.classList.remove("hidden");
        //     else this.dict2.classList.add("hidden");
        // });

        // for dad
        //this.show2(); // TODO: fix race condition
        //window.addEventListener("hashchange", this.show2.bind(this)); // weird bug: does not update; maybe race condition
        window.addEventListener("keydown", (event) => {
            switch (event.code) {
                case "F1":
                    event.preventDefault(); // stop help from showing
                    this.show2("khmer");
                    break;
                case "F2":
                    event.preventDefault();
                    this.show2("pali");
                    break;
            }
        });

        this.addPagerListeners();
        this.addListeners1();
        this.addListeners2();
        this.addListeners3();
        //this.addSpeakListener();

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    private addPagerListeners() {
        this.page.addEventListener("keyup", this.userInput2.bind(this)); // keydown = character not yet detected // keypress is deprecated
        this.page.addEventListener("change", this.processInput.bind(this));

        this.increment.addEventListener("click", (event: Event) =>
            this.pageTo(true)
        );
        this.decrement.addEventListener("click", (event: Event) =>
            this.pageTo(false)
        );
    }

    private renderPager() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);

        this.page.value = page.toString();
        //this.page.dataset.inputCounterMax = this.getTotal(book).toString();
        this.total.textContent =
            this.getTotal(book) + " " + strings.total[LANGUAGE];
        this.maxPage = this.getTotal(book);
    }

    private pageTo(direction: boolean) {
        const paths = window.location.hash.split("/");
        let book = parseInt(paths[2]);
        let page = parseInt(paths[4]);

        if (direction) {
            page = page === this.getTotal(book) ? 0 : page + 1;
        } else {
            page = page === 0 ? this.getTotal(book) : page - 1;
        }

        //window.location.hash = `/book/${book}/page/${page}`;
        window.location.setHash(book, page);
        this.renderPager();
        logEvent(analytics, "page", { direction, book, page });
        this.heartbank.alertAdmin(
            `reader/pager/${direction ? "left" : "right"}`
        );
    }

    private userInput2(event: KeyboardEvent) {
        this.page.value = normalizeNumerals(
            this.page.value,
            this.maxPage
        ).toString();
        //console.log(this.page.value);
        if (event.key === "Enter") this.processInput();
    }

    private processInput() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(this.page.value);
        //window.location.hash = `/book/${book}/page/${isNaN(page) ? 1 : page}`;
        window.location.setHash(book, isNaN(page) ? 0 : page);
        this.renderPager();
        logEvent(analytics, "page", { at: "input", book, page });
    }

    private getTotal(book: number): number {
        return Math.ceil(bedok[LANGUAGE2].books[book - 1] / 2) - 1;
    }

    // temp for dad to quickly add
    private show2(lang: string) {
        //await this.heartbank.waitForAuth();
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        //const page = parseInt(paths[4]);
        if (
            book &&
            this.getAttribute("lang") === lang &&
            this.transcription &&
            this.heartbank.isAdmin()
        ) {
            this.editor.show(this.transcription!, lang, this.transcript, this);
        }
    }

    show() {
        this.renderPager();
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private formatText(text: string, language: "pali" | "khmer"): string {
        return text
            .replace(
                /^([^\n]*)\n\n([^\n]*)\n\n([\s\S]*)$/,
                `<div style="text-align:${language === "khmer" ? "right" : "left"}">$1</div>\n<div style="text-align:center;font-size:1.2em">$2</div>\n$3`
            )
            .replace(/\n/g, "<br>"); //.replaceAll("\n", "<br>") for modern browser
    }

    render(
        language: "pali" | "khmer",
        id: string | null,
        date: Date | null,
        transcript: string | null,
        text: string,
        hasText: boolean,
        audio: string | null
    ) {
        this.transcription = id;
        this.transcript = transcript;
        this.text = text;

        if (date || this.heartbank.isAdmin()) {
            //this.body1.innerHTML = date && hasText ? text.replace(/\n/g, "<br>") : transcript ?? text;  // will show empty for english if edited until dad adds // use innerText too?
            this.body1.innerHTML = transcript
                ? this.formatText(transcript, language)
                : text;
            this.body2.innerHTML = this.body1.innerHTML;
            this.renderDictionary();
        } else {
            this.body1.innerHTML = strings.transcribe4[LANGUAGE];
            this.body2.innerHTML = this.body1.innerHTML;
        }

        if (window.location.hash.split("/")[4] === "0") {
            this.body1.classList.add("text-center");
            this.body2.classList.add("text-center");
            this.body1.classList.remove("text-justify");
            this.body2.classList.remove("text-justify");
        } else {
            this.body1.classList.remove("text-center");
            this.body2.classList.remove("text-center");
            this.body1.classList.add("text-justify");
            this.body2.classList.add("text-justify");
        }

        if (audio) {
            this.audio = new Audio();
            this.audio.src = audio;
            this.audio.load();
            this.audio.addEventListener(
                "ended",
                this.addAudioListener.bind(this)
            );
        } else this.audio = null;

        if (this.transcription && this.heartbank.isAdmin()) {
            this.editButton.classList.add("cursor-pointer");
            this.editIcon.classList.remove("hidden");
            this.admin.classList.replace("hidden", "flex");
        } else {
            this.editButton.classList.remove("cursor-pointer");
            this.editIcon.classList.add("hidden");
            this.admin.classList.replace("flex", "hidden");
        }

        this.speak.disabled = !this.transcription;
        this.dict2.disabled = !this.transcription;
        this.copy.disabled = !this.transcription;
        this.tutor.disabled = !this.transcription;
        this.quiz.disabled = !this.transcription;

        this.body1.classList.remove("hidden");
        this.body2.classList.add("hidden");
    }

    // to prevent adding multiple listeners
    private addAudioListener() {
        if (this.audio) {
            this.audio.pause();
            this.speak.textContent = "🔈"; //strings.speak[LANGUAGE];
        }
    }

    private renderDictionary() {
        const collator = new Intl.Collator("km"); // Khmer locale
        Words.sort((a, b) => {
            const lenDiff = b.word.length - a.word.length;
            return lenDiff !== 0 ? lenDiff : collator.compare(a.word, b.word);
        });

        // Initialize BreakIterator for Khmer word segmentation
        const segmenter = new Intl.Segmenter("km", { granularity: "word" });

        // Get all text nodes in body2
        const walker = document.createTreeWalker(
            this.body2,
            NodeFilter.SHOW_TEXT
        );
        const textNodes: Text[] = [];
        while (walker.nextNode()) {
            const current = walker.currentNode;
            if (
                current.nodeType === Node.TEXT_NODE &&
                current.textContent?.trim()
            ) {
                textNodes.push(current as Text);
            }
        }

        // Process each text node
        for (const textNode of textNodes) {
            const text = textNode.textContent || "";
            if (!text.trim()) continue;

            // Segment text into words using BreakIterator
            const segments: { text: string; start: number; end: number }[] = [];
            let pos = 0;
            for (const { segment, index } of segmenter.segment(text)) {
                const breakPoint = index + segment.length;
                if (segment.trim()) {
                    segments.push({
                        text: segment,
                        start: pos,
                        end: breakPoint
                    });
                }
                pos = breakPoint;
            }

            // Create a document fragment to hold new nodes
            const frag = document.createDocumentFragment();
            let lastIndex = 0;

            // Check each segment for dictionary terms
            for (const segment of segments) {
                // Add text before the segment if needed
                if (lastIndex < segment.start) {
                    frag.appendChild(
                        document.createTextNode(
                            text.slice(lastIndex, segment.start)
                        )
                    );
                }

                // Check if segment matches a dictionary term
                const term = Words.find(
                    (t) => t.word.toLowerCase() === segment.text.toLowerCase()
                );

                if (term) {
                    // Create a range for the matching segment
                    const range = document.createRange();
                    range.setStart(textNode, segment.start);
                    range.setEnd(textNode, segment.end);

                    // Create span element
                    const span = document.createElement("span");
                    span.className =
                        "text-blue-500 cursor-pointer inline-block"; //underline
                    //span.style.display = "inline-block"; // Prevent breaking Khmer text
                    //span.style.cursor = "pointer"; // Indicate clickability
                    span.textContent = segment.text;

                    // Attach click event listener
                    span.onclick = () => {
                        this.hide();
                        this.dictionary.show(this);
                        this.dictionary.renderWord(term.word);
                    };

                    // Add span to fragment
                    frag.appendChild(span);
                } else {
                    // Add non-matching segment as plain text
                    frag.appendChild(document.createTextNode(segment.text));
                }

                lastIndex = segment.end;
            }

            // Add remaining text
            if (lastIndex < text.length) {
                frag.appendChild(
                    document.createTextNode(text.slice(lastIndex))
                );
            }

            // Replace the original text node
            const parent = textNode.parentNode;
            if (parent) {
                parent.replaceChild(frag, textNode);
            }
        }
    }

    // deprecated: only works on chrome and not safari
    private renderDictionary2() {
        const collator = new Intl.Collator("km"); // Khmer locale
        Words.sort((a, b) => {
            const lenDiff = b.word.length - a.word.length;
            return lenDiff !== 0 ? lenDiff : collator.compare(a.word, b.word);
        });

        //let html = this.body1.innerHTML;
        // for (const term of Words) {
        //     const regex = new RegExp(term.word, "gi");
        //     html = html.replace(
        //         regex,
        //         `<span class="text-blue-500 cursor-pointer underline" onclick="">${term.word}</span>`
        //     );
        // }
        //this.body2.innerHTML = html;

        for (const term of Words) {
            const regex = new RegExp(term.word, "gi");
            // const regex = isApple
            //     ? new RegExp(`\\b${term.word}\\b`, "gi")
            //     : new RegExp(term.word, "gi");
            const walker = document.createTreeWalker(
                this.body2,
                NodeFilter.SHOW_TEXT
            );

            const textNodes: Text[] = [];
            while (walker.nextNode()) {
                const current = walker.currentNode;
                if (
                    current &&
                    current.nodeType === Node.TEXT_NODE &&
                    current.textContent
                ) {
                    textNodes.push(current as Text);
                }
            }

            for (const textNode of textNodes) {
                const text = textNode.textContent!;
                const matches = [...text.matchAll(regex)];
                if (matches.length === 0) continue;

                const frag = document.createDocumentFragment();
                let lastIndex = 0;

                for (const match of matches) {
                    const matchText = match[0];
                    const matchIndex = match.index!;

                    // Add plain text before match
                    frag.appendChild(
                        document.createTextNode(
                            text.slice(lastIndex, matchIndex)
                        )
                    );

                    // Create span element
                    const span = document.createElement("span");
                    span.className = "text-blue-500 underline"; // TODO: later set time out for cursor pointer
                    span.textContent = matchText;
                    // TODO: listen for click event at parent; set id attribute
                    span.onclick = () => {
                        this.hide();
                        this.dictionary.show(this);
                        this.dictionary.renderWord(matchText); // TODO: later do renderID?? need to refactor function to handle history
                    };
                    frag.appendChild(span);

                    lastIndex = matchIndex + matchText.length;
                }

                // Add remaining text
                frag.appendChild(
                    document.createTextNode(text.slice(lastIndex))
                );

                // Replace the original text node
                const parent = textNode.parentNode;
                if (parent) {
                    parent.replaceChild(frag, textNode);
                }
            }
        }
    }

    private isAudioPlaying(): boolean {
        return (
            !this.audio!.paused &&
            !this.audio!.ended &&
            this.audio!.currentTime > 0
        );
    }

    private addListeners1() {
        this.speak.addEventListener("click", async () => {
            if (this.audio) {
                if (this.isAudioPlaying()) {
                    this.audio.pause();
                    this.speak.textContent = "🔈"; //strings.speak[LANGUAGE];
                } else {
                    this.audio.play();
                    this.speak.textContent = "🔇"; //strings.stop[LANGUAGE];
                }
            } else {
                // let text;
                // try {
                //     text = await navigator.clipboard.readText();
                // } catch {
                //     text = this.transcript || "";
                // }

                const encodedText = encodeURIComponent(this.transcript || ""); //text
                const translateUrl = `https://translate.google.com/?sl=auto&tl=${strings.language[LANGUAGE]}&text=${encodedText}&op=translate`;
                window.open(translateUrl, "_blank");
            }
        });

        this.dict2.addEventListener("click", () => {
            if (this.body2.classList.contains("hidden")) {
                this.body2.classList.remove("hidden");
                this.body1.classList.add("hidden");
            } else {
                this.body2.classList.add("hidden");
                this.body1.classList.remove("hidden");
            }
        });

        this.copy.addEventListener("click", async () => {
            if (this.transcript) {
                const paths = window.location.hash.split("/");
                const book = parseInt(paths[2]);
                const page = parseInt(paths[4]); // not used for now
                const basket = this.books.getBasket(book);

                const text = `${
                    strings.baskets3[LANGUAGE][basket]
                }: ${book.toKhmer(LANGUAGE)}\n\n${
                    strings.page[LANGUAGE]
                }: ${this.transcript.replace("<hr>", "")}\n\n${
                    window.location.href
                }`;
                await navigator.clipboard.writeText(text); // this.body.innerText // copy original khmer text, not english translation
                this.dispatchEvent(
                    new CustomEvent<{ info: string }>("sw-banner", {
                        bubbles: true,
                        detail: {
                            info: strings.copied2[LANGUAGE]
                        }
                    })
                );
            } else {
                alert(strings.copyError[LANGUAGE]);
            }
        });

        this.tutor.addEventListener("click", async () => {
            if (this.transcript) {
                await navigator.clipboard.writeText(
                    strings.tutor3[LANGUAGE] + this.transcript
                );
                this.dispatchEvent(
                    new CustomEvent<{ info: string }>("sw-banner", {
                        bubbles: true,
                        detail: {
                            info: strings.tutor2[LANGUAGE]
                        }
                    })
                );
            }
        });

        this.quiz.addEventListener("click", async () => {
            if (this.transcript) {
                await navigator.clipboard.writeText(
                    strings.quiz3[LANGUAGE] + this.transcript
                );
                this.dispatchEvent(
                    new CustomEvent<{ info: string }>("sw-banner", {
                        bubbles: true,
                        detail: {
                            info: strings.quiz2[LANGUAGE]
                        }
                    })
                );
            }
        });

        this.dict.addEventListener("click", async () => {
            let text;
            try {
                text = await navigator.clipboard.readText();
            } catch {
                text = this.transcript || "";
            }
            this.hide();
            this.dictionary.show(this);
            this.dictionary.renderWord(text);
        });

        this.close.addEventListener("click", this.hide.bind(this));
        this.close2.addEventListener("click", this.hide.bind(this));
    }

    private addListeners2() {
        this.google.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = `https://translate.google.com/?sl=${strings.language[LANGUAGE]}&tl=en&op=translate`;
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });

        this.chatgpt.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://chat.openai.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`; // pro has string length limit
            window.open(baseUrl, "_blank");
        });

        this.grok.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://grok.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
    }

    private addListeners3() {
        this.deepseek.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://chat.deepseek.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });

        this.gemini.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://gemini.google.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });

        this.meta.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://www.meta.ai/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });

        this.other.addEventListener("click", async () => {
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }

            const baseUrl = "https://huggingface.co/chat/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
    }

    // deprecated
    private addSpeakListener() {
        this.speak.addEventListener("click", async () => {
            const text = await navigator.clipboard.readText();
            try {
                const response = await fetch(
                    `${SW_AI}/textToSpeech?text=${encodeURIComponent(text)}`
                );
                const data = await response.json();
                if (response.ok) {
                    const audioUrl = URL.createObjectURL(data.blob());
                    const audio = new Audio(audioUrl);
                    audio.play();
                }
            } catch (error: any) {
                console.error(error.message);
            }
        });

        this.speak.addEventListener("click", async () => {
            const synth = window.speechSynthesis;
            if (synth.speaking) {
                synth.cancel();
                this.speak.textContent = strings.speak2[LANGUAGE];
            } else {
                const text = await navigator.clipboard.readText();
                const utterance = new SpeechSynthesisUtterance(text);
                const voices = synth.getVoices();
                const khmerVoice = voices.find((voice) =>
                    voice.lang.startsWith("km")
                );
                if (khmerVoice) {
                    utterance.voice = khmerVoice;
                } else {
                    console.warn("Khmer voice not found in Web Speech API.");
                }
                synth.speak(utterance);
                this.speak.textContent = strings.stop2[LANGUAGE];
                utterance.onend = (event) => {
                    this.speak.textContent = strings.speak2[LANGUAGE];
                };
            }
        });
    }
}
